// @flow

import createVersions from './create-versions';
import queries from './queries_node';

export default createVersions('node', queries, true);
